import PropTypes from "prop-types";
import config from "config";
import ErrorIndicator from "./ErrorIndicator";

/**
 * Last-resort error surface rendered by `ErrorBoundary`.
 *
 * Deliberately self-contained: it must paint even when routing, redux or a
 * route subtree is what threw, so it only uses plain markup plus the globally
 * loaded Bootstrap classes. The raw error message is never rendered here.
 */
const ErrorFallback = ({ reference, onRetry, chunkFailure = false }) => (
  <div className="container" role="alert" data-testid="error-boundary-fallback">
    <div className="row justify-content-center align-items-center min-vh-100">
      <div className="col-md-7 col-lg-6">
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center p-4 p-md-5">
            <div className="mb-3"><ErrorIndicator /></div>
            <h1 className="h4 mb-3">Something went wrong</h1>
            <p className="text-muted mb-4">
              This page could not be displayed because of an unexpected error.
              Your data is safe. Try loading it again, or return to the home
              page to keep working.
            </p>
            {chunkFailure && <p role="status">The app could not load an updated page. Refresh your browser to load the latest version. If this continues, please try again later.</p>}
            <div className="d-flex flex-wrap gap-2 justify-content-center">
              <button type="button" className="btn btn-primary" onClick={onRetry}>
                Try again
              </button>
              <a className="btn btn-outline-secondary" href={config.basePath || "/"}>
                Go to home page
              </a>
            </div>
            {reference ? (
              <p className="text-muted small mt-4 mb-0">
                Reference: <code>{reference}</code>
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  </div>
);

ErrorFallback.propTypes = {
  reference: PropTypes.string,
  chunkFailure: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
};

export default ErrorFallback;
